import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export interface SeoPageData {
  id: string;
  slug: string;
  title: string;
  meta_description: string;
  canonical_url: string | null;
  og_title: string | null;
  og_description: string | null;
  og_image: string | null;
  robots_directive: string;
  keywords: string | null;
  structured_data_json: any;
  is_active: boolean;
}

export function useSeoPage(slug: string) {
  const [seoData, setSeoData] = useState<SeoPageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadSeoData() {
      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('seo_pages')
          .select('*')
          .eq('slug', slug)
          .eq('is_active', true)
          .maybeSingle();

        if (fetchError) {
          console.error('Error loading SEO data:', fetchError);
          setError(fetchError.message);
          return;
        }

        setSeoData(data);
      } catch (err) {
        console.error('Error loading SEO data:', err);
        setError('Failed to load SEO data');
      } finally {
        setLoading(false);
      }
    }

    loadSeoData();
  }, [slug]);

  return { seoData, loading, error };
}
